module.exports = __webpack_public_path__ + "img/dg.aa65bbdb.jpg";